import React, { memo, useCallback } from 'react'

import { shape, string, bool, func, number } from 'prop-types'

function ImageSlide({ media, title, isFirstImage, loadLowQualityImage = false, onLoad, onError, slideIndex }) {
  const { model, imageName } = media
  const { imageName: modelImageName } = model ?? {}
  const { url: fullscreenVariantUrl, large: largeVariant } = modelImageName ?? {}
  const { url: largeVariantUrl } = largeVariant ?? {}

  const fullScreenImageUrl = fullscreenVariantUrl || imageName
  const largeImageUrl = largeVariantUrl || imageName
  const imageUrl = (() => {
    if (loadLowQualityImage) {
      return largeImageUrl || imageName
    }

    return fullScreenImageUrl || largeVariantUrl
  })()

  const handleLoad = useCallback(() => {
    if (onLoad) {
      onLoad(slideIndex)
    }
  }, [onLoad, slideIndex])

  const handleError = useCallback(() => {
    if (onError) {
      onError(slideIndex)
    }
  }, [onError, slideIndex])

  return (
    <img
      alt={title}
      className="gallery-area-top-carousel__image"
      src={imageUrl}
      loading={isFirstImage ? 'eager' : 'lazy'}
      fetchpriority={isFirstImage ? 'high' : 'auto'} // eslint-disable-line react/no-unknown-property
      decoding={isFirstImage ? 'sync' : 'async'}
      width={418}
      height={418}
      onLoad={handleLoad}
      onError={handleError}
    />
  )
}

ImageSlide.propTypes = {
  media: shape({
    model: shape({}),
    imageName: string,
  }).isRequired,
  title: string.isRequired,
  isFirstImage: bool.isRequired,
  loadLowQualityImage: bool,
  onLoad: func,
  onError: func,
  slideIndex: number,
}

export default memo(ImageSlide)
